/* @flow */

import React from 'react'
import Link from 'gatsby-link'
// import NounBox from '../components/NounBox'
import BlogRoll from '../components/BlogRoll'
import Checkout from '../components/checkout'

// homepage
const INDEX = () => (
  <section className='body-bg-offwhite'>
    <section className='container-homepage align-start'>
      <section className='flex-box align-center just-center homepage-hero'>
        <div>
          <h3>NEVER STOP LEARNING. GROWING. BUILDING YOUR CAREER.</h3>
          <Link className='btn btn-icon-right marg-t-1 weight-700 bg-white clr-primary-darker' to='/about/introduction/'>
            Learn More<i className='fa fa-arrow-right marg-l-1' />
          </Link>
        </div>
      </section>
    </section>
    <section className='container-homepage'>
      <Link className='link-card btn btn-icon-right weight-700' to='/about/introduction/' >
        <div className='flex-box dir-column marg-l-1 marg-r-1'>
          <h3 className='marg-b-1 clr-primary-darker'>Who are We</h3>
          <section className='smallest'>
            <ul>
              <li>A team of experience financial markets professional from various functional areas of the domain</li>
            </ul>
          </section>
          <h3 className='marg-b-1 clr-primary-darker'>Reason to Subscribe</h3>
          <section className='smallest'>
            <ul>
              <li>You can't find this online, I tried</li>
            </ul>
          </section>
          <h3 className='marg-b-1 clr-primary-darker'>Reason to Pay the Price</h3>
          <section className='smallest'>
            <ul>
              <li>A choice between ready made information and the pain we went thru to gain these experiences. Your choice.</li>
            </ul>
          </section>
          <h3 className='marg-b-1 clr-primary-darker'>Upside to Subscribing and Paying the Price</h3>
          <section className='smallest'>
            <ul>
              <li>If you are out there to find a job in this domain area, having this knowledge would dramatically increase your chances of getting employed.</li>
              <li>If you are out there to get a promotion or show value, trust me in my years working in this industry, I am certain these experiences we are imparting would put you ahead of the pack.</li>
            </ul>
          </section>
        </div>
        {/* <img style={{width: '300px', height: '100%'}} src='/img/success.jpg'/> */}
      </Link>
      <section className='link-cardNew btn btn-icon-right weight-700' style={{ background: '#ffc107' }}>
        {/* <section className='link-card btn btn-icon-right weight-700' style={{backgroundImage: "url(/img/success_small.jpg)"}}> */}
        <div className='flex-box dir-column marg-l-1 marg-r-1'>
          <h3 className='marg-b-1 clr-primary-darker'>Free Article to Get You Started</h3>
          There are a couple of free to browse sections so feel free to visit these pages.<br /><br />
          <section className='smallest'>
            <ul>
              <li><a href='/processes/frontoffice/Pricing/'>Pricing Overview</a></li>
              <li><a href='/processes/frontoffice/PreDealChecks/'>Pre-Deal Check Overview</a></li>
              <li><a href='/processes/frontoffice/TransactionExecution/'>Execute Transaction Overview</a></li>
              <li><a href='/processes/credit_risk/credit_risk_control/'>Credit Risk Control Overview</a></li>
              <li><a href='/processes/market_risk/market_risk_control/'>Market Risk Control Overview</a></li>
              <li><a href='/processes/operations/confirmations/'>Confirmations Overview</a></li>
              <li><a href='/processes/operations/settlement/'>Settlements Overview</a></li>
              <li><a href='/processes/finance/accounting/'>Accounting Overview</a></li>
            </ul>
          </section>
        </div>
      </section>
    </section>

    <section className='container-homepage'>
      <section className='flex-box dir-column just-between homepage-link-list'>
        <Link className='link-card btn btn-icon-right weight-700' to='/about/pricing/'>
          <img className='' src='/img/lightbulb.svg' />
          <div className='flex-box dir-column marg-l-1 marg-r-1'>
            <h3 className='marg-b-1 clr-primary-darker'>Subscribe Now</h3>
            <section className='smallest'>SGD$25 for access to all current materials and other materials that we are providing for the year of 2019.</section>
            <br />
            <Checkout />
          </div>
          <i className='fa fa-angle-right fa-2x marg-l-1' />
        </Link>
        <Link className='link-card btn btn-icon-right weight-700' to='/about/topics_available/'>
          <img className='' src='/img/line-graph.svg' />
          <div className='flex-box dir-column marg-l-1 marg-r-1'>
            <h3 className='marg-b-1 clr-primary-darker'>Available Topics</h3>
            <section className='smallest'>Get an overview of Trade Lifecycle fundamentals in financial markets domain right now right here.</section>
          </div>
          <i className='fa fa-angle-right fa-2x marg-l-1' />
        </Link>
        <Link className='link-card btn btn-icon-right weight-700' to='/about/topics_roadmap/'>
          <img className='' src='/img/download.svg' />
          <div className='flex-box dir-column marg-l-1 marg-r-1'>
            <h3 className='marg-b-1 clr-primary-darker'>Topic Roadmap</h3>
            <section className='smallest'>We will be kicking off the next set of content based on the scenario of setting up a new entity. These will touch upon everything front to back and provide you with in-depth knowledge of the various processes and concepts required for a functioning financial market business </section>
          </div>
          <i className='fa fa-angle-right fa-2x marg-l-1' />
        </Link>
      </section>

      <BlogRoll
        small={true}
      />
    </section>
  </section>
)

INDEX.displayName = 'Homepage'
export default INDEX



// WEBPACK FOOTER //
// ./src/pages/index.jsx